import gql from 'graphql-tag';

export const QUERY_NOTIFICATION_LIST = gql`
  query CMS_NotificationList(
    $filters: [ListNotificationsFilter]
    $pageSize: PositiveInteger
    $pageNumber: PositiveInteger
    $sorts: [CrmNotificationSort]
  ) {
    listNotifications(
      filters: $filters
      sorts: $sorts
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      edges {
        node {
          id
          name
          publishStart
          publishEnd
          publishType
          channels
          combinedBy
          redirectType
          redirectValue
          name
          messageTitle
          messageContent
          waitTime
          updatedBy
          triggerCondition {
            registered
            destinationCity
            locales
            oppLost {
              start
              end
              lost
            }
            activeTime {
              start
              end
            }
          }
          status
          createdAt
          updatedAt
          updatedByCmsUser {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const CREATE_NOTIFICATION = gql`
  mutation createNotification($input: CreateNotificationInput!) {
    createNotification(input: $input) {
      notification {
        id
      }
    }
  }
`;

export const UPDATE_NOTIFICATION = gql`
  mutation updateNotification($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      notification {
        id
      }
    }
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation deleteNotification($input: DeleteNotificationInput!) {
    deleteNotification(input: $input) {
      notification {
        id
      }
    }
  }
`;

export const QUERY_EST_NOTIFICATION = gql`
  query countSatisfyNotificationStudent($filters: [CrmTagFilter!]!) {
    countSatisfyNotificationStudent(filters: $filters) {
      count
    }
  }
`;
